import { WaterTestAPI } from '@/api';
import kirill_format from './kirill-format.data'

const default_form = {
  name: '',
  fieldId: '',
  farmId: '',
  date: '',
  name: '',
  testId: 1,
  data: [],
  amounts: 0,
  irregation: 0,
  ph: null,
  ec: null,
};

export default {
  namespaced: true,
  state: {

    form: JSON.parse(JSON.stringify(default_form)),

    maxNCount: null,

    is_creating: false,

  },
  mutations: {
    setForm(state, form) {
      state.form = form;
    },
    clearForm(state) {
      state.form = JSON.parse(JSON.stringify(default_form));
    },
    setData(state, data) {
      state.form.data = data;
      state.form.data.map(item => {
        if (item.value === null) {
          item.value = 0;
        }
        return item;
      });
    },
    setCreateMode(state, mode) {
      state.is_creating = mode;
    },
    computeN(state, { use_n_form }) {
      const data = state.form.data;
      const NO3 = parseFloat(data.find(n => n.key === 'NNO3').value) || 0;
      const NH4 = parseFloat(data.find(n => n.key === 'NNH4').value) || 0;
      const NH2 = parseFloat(data.find(n => n.key === 'NNH2').value) || 0;
      const N = data.find(n => n.key === 'N');

      if(use_n_form)
        N.value = (NO3 + NH4 + NH2).toFixed(2)
      else N.value = 0

      state.maxNCount = (NO3 + NH4 + NH2);
    },

    setMax(state, { value }) {
      state.maxNCount = value
    }
  },
  actions: {

    createTest({ commit, dispatch, state, getters, rootGetters }) {
      let data = JSON.parse(JSON.stringify(state.form))
      data.ec = rootGetters['unit/unConvert']('dS/m', data.ec)
      const form = { ...data };
      form.data = JSON.stringify(getters.adapterNormalToKirillFormat());
      
      return WaterTestAPI.create(form).then(res => {
        if(rootGetters['tests/sidebar/filters'].type == 'water-anal') {
          dispatch('tests/sidebar/updateData', null, { root: true });
        }
        return res.data.data;
      });
    },


    save({ commit, dispatch, state, getters, rootGetters }) {
      // TODO: refactor and do processing on BACKEND
      const form = { ...state.form };
      form.data = JSON.stringify({
        values: getters.adapterNormalToKirillFormat(),
        ec: form.ec,
        ph: form.ph,
        interpretations: form.interpretations,
      });


      return WaterTestAPI.save(form.id, form).then(res => {
        if(rootGetters['tests/sidebar/filters'].type == 'water-anal') {
          dispatch('tests/sidebar/updateData', null, { root: true });
        }
        return res.data.data;
      });
    },


    deleteTest({ commit, dispatch, state, getters, rootGetters }) {
      return WaterTestAPI.remove(state.form.id).then(res => {
        if(rootGetters['tests/sidebar/filters'].type == 'water-anal') {
          dispatch('tests/sidebar/updateData', null, { root: true });
        }
      });
    },


    getSingle({ commit, dispatch, state, getters }, test) {

      return WaterTestAPI.getAlanysis(test).then(res => {
        // TODO: убрать нахуй и что бы на бэке это все парсило и не присылало в одну data
        const data = res.data.data;
        data.data = JSON.parse(data.data);
        data.ec = data.data.ec || 0;
        data.ph = data.data.ph || 0;
        data.interpretations = data.data.interpretations;
        data.data = getters.adapterKirillToNormalFormat(data.data.values);

        commit('setForm', data);
        dispatch('parseDataToLatestVersion');
      });
    },

    async computeEC({ commit, dispatch, state, getters, rootGetters }) {
      var anionValue = await dispatch('CalculateAnion');
      var cationValue = await dispatch('CalculateCation');
      var allIonValue = await dispatch('CalculateAllIon');

      state.form.ec = ((anionValue + cationValue + allIonValue) / 3).toFixed(2)/1;

      return state.form.ec;
    },
    async CalculateAnion ({ commit, dispatch, state, getters, rootGetters }) {
      return (await getters.getMeq('Cl') +
        await getters.getMeq('HCO3') +
        await getters.getMeq('NO3') +
        await getters.getMeq('P') +
        await getters.getMeq('S')
      ) / 10;
    },
    async CalculateCation ({ commit, dispatch, state, getters, rootGetters }) {
      return (await getters.getMeq('Ca') +
        await getters.getMeq('Mg') +
        await getters.getMeq('Na') +
        await getters.getMeq('NH2') +
        await getters.getMeq('NH4')
      ) / 10;
    },
    async CalculateAllIon ({ commit, dispatch, state, getters, rootGetters }) {
      var result = 0;
      result += await getters.getMeq('Ca') / 1000 * 2;
      result += await getters.getMeq('Mg') / 1000 * 2;
      result += await getters.getMeq('S')  / 1000 * 2;
      result += await getters.getMeq('NH4') / 1000;
      result += await getters.getMeq('NO3') / 1000;
      result += await getters.getMeq('Na') / 1000;
      result += await getters.getMeq('HCO3') / 1000;
      result += await getters.getMeq('Cl') / 1000;

      return (0.5 * result) / 0.013;
    },

    // TODO: ПЕРЕМЕСТИТЬ В ГЕТТЕРЫ!!!!!!!!!!!!!!!!!!!!!!!!
    // getMeq ({ commit, dispatch, state, getters, rootGetters }, nut) {
    //   var temp = state.form.data.find(n => n.key === nut);
    //   if (temp) {
    //     return rootGetters['nutrients/getUnitFromPPm'](nut, 'meq*', temp.value);
    //   } else {
    //     var temp_nut = 'N' + nut;
    //     temp = state.form.data.find(n => n.key === temp_nut);
    //     // var temp_val = rootGetters['nutrients/getVal'](temp_nut, nut, temp.value);

    //     return temp.value / 14;
    //   }

    // },

    /**
     *
     * Это надо что бы если вдруг обновится список нутриентов
     * оно должно добавить недостающие нутриенты в нынешней дате
     */
    parseDataToLatestVersion() {
      // TODO: )))
    },

    initDefaultData({ commit, rootGetters, getters }) {
      commit('setData', getters.getNormalFormat());
    },
  },
  getters: {
    getMeq: (state, getters, rootState, rootGetters) => nut => {
      var temp = state.form.data.find(n => n.key === nut);
      if (temp) {
        return rootGetters['nutrients/getUnitFromPPm'](nut, 'meq/L', temp.value);
      } else {
        var temp_nut = 'N' + nut;
        temp = state.form.data.find(n => n.key === temp_nut);
        // var temp_val = rootGetters['nutrients/getVal'](temp_nut, nut, temp.value);

        return temp.value / 14;
      }

    },


    form(state) {
      return state.form
    },

    /**
     * Сложная хуета для парса двух форматов , когда у кирилла будет больше времени заменим
     * что бы норм было
     *
     * объясняю - кирилл попросил передавать данные в другом формате ,
     * но я уже успел по своему сделать
     * На первое время пойдет , но он по сути не правильный , я не хочу тут
     * устраивать Алазара номер два
     *
     * По этому и сделал функции для парса моего формата в его и обратно
     */
    adapterNormalToKirillFormat: state => () => {
      let obj = {};
      for (const key in kirill_format) {
        try {
          if(key != 'CO3_Val' && key != 'F_Val' && key != 'Al_Val' && key != 'CL_Val')
            obj[key] = state.form.data.find(n => n.key == kirill_format[key]).value;
        } catch (error) {
          console.error('Some of nutrients are missing in your data, compare kirill-format.data and global nutrients');
        }
      }
      return obj;
    },

    /**
     * Сложная хуета для парса двух форматов , когда у кирилла будет больше времени заменим
     * что бы норм было
     */
    adapterKirillToNormalFormat: (state, getters) => data => {
      return getters.getNormalFormat()
        .map(n => {
          for (const key in kirill_format) {
            if(kirill_format[key] == n.key) {
              n.value = data[key];
            }
          }
          return n;
        });

    },

    /**
     * Вот это формат в котором должно отсылаться на сервер (Normal)
     */
    getNormalFormat: (state, getters, rootState, rootGetters) => () => {
      return [
        ...rootGetters['nutrients/nForms'].map(n => {
          return {
            key: n.key,
            n_form: true,
            value: null,
            units: n.units
          }
        }),
        ...rootGetters['nutrients/data'].map(n => {
          return {
            key: n.key,
            micro: true,
            value: null,
            units: n.units
          }
        }).filter(n => n.key != 'Al'),
      ]
    },

    isCreating(state) {
      return state.is_creating
    },

    getDataRowByNutrient: state => key => {
      return state.form.data.find(n => n.key == key);
    },

    warnings(state) {
      let array = [];
      const warnings = state.form.interpretations;
      const suffix_to_delete = '_Interpretation';
      for (const key in warnings) {
        if(warnings[key] == 'Excessive') {
          array.push({
            value: warnings[key],
            key: key.replace(suffix_to_delete, ''),
          });
        }
      }
      return array;
    }
  }
};
